module.exports = __webpack_public_path__ + "assets/img/trevor.f58b25b2.jpg";